import { ChangeDetectionStrategy, Component, effect, input } from '@angular/core';
import { PrevisionService } from '@core/services/prevision.service';
import { IPrevisionesInterna, IPrevisionInterno } from '@models/IPrevisiones';
import { PrevisionInternaTableComponent } from '@shared/prevision-interna-table/prevision-interna-table.component';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-ultimas-previsiones-internas',
  imports: [PrevisionInternaTableComponent],
  templateUrl: './ultimas-previsiones-internas.component.html',
  styleUrl: './ultimas-previsiones-internas.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UltimasPrevisionesInternasComponent {
  
  ultimasPrevisiones: IPrevisionesInterna = [];

  centroId = input<number>();

  constructor(
    private pervisionService: PrevisionService,
    private logger: NGXLogger
  ) {
    effect(() => {
      const id = this.centroId();
      if (id) {
        this.getPrevisones(id);
      }
    });
  }

  getPrevisones(centro?: number) {
    const dates = this.pervisionService.calculateWeekRange();

    this.logger.info('interno => ',dates);

    this.pervisionService
      .getPrevisionInternaByDates(dates.beginDate, dates.endDate, centro)
      .subscribe((res) => {
        const previsiones = this.setActionValueDefault(res)
        this.ultimasPrevisiones = previsiones;
      }
    );
  }


  // ESTA FUNCION SE HACE PARA QUE EL VALOR POR DEFECTO DE TODAS LAS LINEAS DE LA TABLA SEA 'E'
  // TIENE QUE SER 'E' PORQUE EN LA TABLA SOLO SE MUESTRAN SI SON IGUAL A 'E' O 'A'.
  // ESTO ES PORQUE LA LOGICA DEL BACKEND PARA CREAR, EDITAR O ELIMINAR FILA SE MANEJA SEGUN EL VALOR DE 'actionValor'
  setActionValueDefault(previsiones: IPrevisionInterno[]): IPrevisionInterno[] {
    return previsiones.map((p) => ({
      ...p,
      actionValor: 'E' as const,
      id: p.id,
      pedido: p.pedido,
      fecha: p.fecha,
      lineas: p.lineas
    }));
  }
}
